import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { AuthorizationService } from 'src/services/authorization.service';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app.routing';
import { DatePipe } from '@angular/common';
import { CustomPopupComponent } from './popup-notification/custom-popup/custom-popup.component';
@NgModule({
  declarations: [
    AppComponent,
    CustomPopupComponent,
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    NgxExtendedPdfViewerModule,

  ],
  providers: [AuthorizationService],
  bootstrap: [AppComponent]
})
export class AppModule { }
